import { Text } from '@backyard-ui/core'

type Shop = {
  id: string
  name: string
}

type ShopResumeProps = {
  shop: Shop
  isLMFreight?: boolean
}

const ShopResume = (props: Readonly<ShopResumeProps>) => {
  const { shop, isLMFreight = false } = props
  const isExternalSeller = shop.id !== 'leroy'

  if (isExternalSeller && isLMFreight) {
    return (
      <div className="whitespace-nowrap">
        <Text size="md" color="gray-500" data-testid="shop-resume-lm-freight">
          Vendido por <strong className="text-black">{shop.name}</strong> e
          entregue por <strong className="text-black">LEROY MERLIN</strong>
        </Text>
      </div>
    )
  }

  const sellerDisplayName = isExternalSeller
    ? shop.name
    : shop.name?.toUpperCase()

  return (
    <div className="whitespace-nowrap">
      <Text size="md" color="gray-500" data-testid="shop-resume-standard">
        Vendido e entregue por{' '}
        <strong className="text-black">{sellerDisplayName}</strong>
      </Text>
    </div>
  )
}

export default ShopResume
